<p-dialog
  #dialog
  [(visible)]="visible"
  [header]="normalizedHeader"
  [draggable]="draggable"
  [keepInViewport]="keepInViewport"
  [resizable]="resizable"
  [modal]="modal"
  [position]="position"
  [blockScroll]="blockScroll"
  [closeOnEscape]="closeOnEscape"
  [dismissableMask]="dismissableMask"
  [closable]="closable"
  [appendTo]="appendTo"
  [style]="style"
  [styleClass]="styleClass"
  [maskStyleClass]="maskStyleClass"
  [contentStyle]="contentStyle"
  [contentStyleClass]="contentStyleClass"
  [showHeader]="showHeader"
  [baseZIndex]="baseZIndex"
  [autoZIndex]="autoZIndex"
  [minX]="minX"
  [minY]="minY"
  [focusOnShow]="focusOnShow"
  [focusTrap]="focusTrap"
  [maximizable]="maximizable"
  [breakpoints]="breakpoints"
  [closeIcon]="closeIcon"
  [minimizeIcon]="minimizeIcon"
  [maximizeIcon]="maximizeIcon"
  (onShow)="onShow($event)"
  (onHide)="onHide($event)"
  (onResizeInit)="onResizeInit($event)"
  (onResizeEnd)="onResizeEnd($event)"
  (onDragEnd)="onDragEnd($event)"
  (onMaximize)="onMaximize($event)"
>
  <ng-template *ngIf="!header" pTemplate="header">
    <div>
      <ng-content select="[header]"> </ng-content>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <ng-content select="[content]"></ng-content>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between">
      <div><ng-content select="[footer-left]"></ng-content></div>
      <div>
        <ng-content select="[footer-right]"></ng-content>
      </div>
    </div>
  </ng-template>
</p-dialog>
